import { useMemo } from 'react'
import NextLink from 'next/link'

import { Text } from '@wartek-id/text-v1'
import { Button } from '@wartek-id/button-v1'

import { Header } from 'app/KinerjaShared/components/Header'
import usePeriodContext from 'app/KinerjaShared/hooks/usePeriodContext'
import { PageGuardGpkPelaksanaanStatus } from 'app/KinerjaGpkPage/components/PageGuardGpkPelaksanaanStatus'
import {
  SectionCard,
  SectionCardHeader,
  SectionCardBody,
  SectionCardFooter,
} from 'app/KinerjaShared/components/SectionCard'
import { PelaksanaanPegawaiHasilObservasiPraktikKinerja } from 'app/KinerjaGpkPage/components/PelaksanaanPegawaiHasilObservasiPraktikKinerja'
import { PENGELOLAAN_KINERJA_GPK_PEGAWAI_PATH } from 'app/KinerjaShared/constants/path'
import { useSafeBackNavigation } from 'app/KinerjaShared/hooks/useSafeBackNavigation'

import type { MultiPeriodPayload } from 'types/kinerja'

type ObservasiRencanaTindakLanjutProps = {
  periodParams?: MultiPeriodPayload
}

export function ObservasiRencanaTindakLanjut({
  periodParams,
}: ObservasiRencanaTindakLanjutProps) {
  const { periodNo, periodYear } = usePeriodContext()

  const { handleBack } = useSafeBackNavigation({
    fallbackRoute: `${PENGELOLAAN_KINERJA_GPK_PEGAWAI_PATH}/pelaksanaan/praktik-kinerja`,
  })

  // -----------------------------------------
  // Resolve period params
  // -----------------------------------------
  const resolvedPeriodParams = useMemo(() => {
    if (periodParams) return periodParams

    // Default with current period
    return {
      skpPeriod: periodNo,
      skpYear: periodYear,
    }
  }, [periodParams, periodNo, periodYear])

  return (
    <main className="pt-12 px-8 pb-8">
      <div className="mx-auto max-w-7xl">
        <PageGuardGpkPelaksanaanStatus periodParams={resolvedPeriodParams}>
          <div className="flex justify-between items-center">
            <Header
              title="Rencana Tindak Lanjut"
              className="mb-9"
              onBack={handleBack}
            />
          </div>
          <SectionCard>
            <SectionCardHeader variant="light-blue">
              <Text as="h2" color="inherit" variant="heading-lg">
                Hasil Observasi Praktik Kinerja
              </Text>
            </SectionCardHeader>
            <SectionCardBody className="px-9 py-6 space-y-12">
              <PelaksanaanPegawaiHasilObservasiPraktikKinerja
                periodParams={resolvedPeriodParams}
              />
            </SectionCardBody>
            <SectionCardFooter className="justify-end">
              <NextLink
                href={`${PENGELOLAAN_KINERJA_GPK_PEGAWAI_PATH}/pelaksanaan/praktik-kinerja/rencana-tindak-lanjut`}
                passHref
              >
                <Button as="a" type={undefined} color="blue" size="lg">
                  Ke Rencana Tindak Lanjut
                </Button>
              </NextLink>
            </SectionCardFooter>
          </SectionCard>
        </PageGuardGpkPelaksanaanStatus>
      </div>
    </main>
  )
}
